import { ToggleButton, ToggleButtonGroup } from '@chronosphereio/chrono-ui';
import { produce } from 'immer';
import { DEFAULT_TOOLTIP_CONFIG } from '@/components';
import { TooltipSort, TooltipSpecOptions } from '@/core';
import { OptionsEditorControl } from '@/plugin-editor-components';

export interface TooltipOptionsEditorProps {
  value?: TooltipSpecOptions;
  onChange: (legend?: TooltipSpecOptions) => void;
}

// TODO: convert to SettingsAutocomplete instead of ToggleButtonGroup
export function TooltipOptionsEditor({ value = {}, onChange }: TooltipOptionsEditorProps) {
  return (
    <>
      <OptionsEditorControl
        label="Mode"
        control={
          <ToggleButtonGroup
            value={value.mode ?? DEFAULT_TOOLTIP_CONFIG.mode}
            onChange={(__, newValue) => {
              onChange({
                ...value,
                mode: newValue,
              });
            }}
          >
            <ToggleButton value="single">Single</ToggleButton>
            <ToggleButton value="nearby">Nearby</ToggleButton>
          </ToggleButtonGroup>
        }
      />
      <OptionsEditorControl
        label="Sort"
        control={
          <ToggleButtonGroup
            value={value.sort ?? 'Auto'}
            onChange={(__, newValue: TooltipSort | 'Auto') => {
              const nextState = produce(value, (draft) => {
                draft.sort = newValue === 'Auto' ? undefined : newValue;
              });
              onChange(nextState);
            }}
          >
            <ToggleButton value="Auto">Auto</ToggleButton>
            <ToggleButton value="None">None</ToggleButton>
            <ToggleButton value="Descending">Descending</ToggleButton>
          </ToggleButtonGroup>
        }
      />
    </>
  );
}
